import React from "react";
import ServiceCard from "../components/ServiceCard";
import DecorativeCircle from "../components/DecorativeCircle";
import BookUsBanner from "../components/BookUsBanner";
import PhotoGallery from "../components/PhotoGallery";

import photoConsult from "../images/photos/DSCF3853.jpg";
import photoConsult2 from "../images/photos/DSCF3829.jpg";
import photoExam from "../images/photos/DSCF3840.jpg";
import photoExam2 from "../images/photos/DSCF3874.jpg";
import photoExam3 from "../images/photos/DSCF3876.jpg";
import photoWaiting from "../images/photos/DSCF3832.jpg";
import photoReception from "../images/photos/DSCF3793.jpg";
import photoFisio from "../images/photos/fisio.jpg";
import {
  NeurologyIcon,
  PhysiatryIcon,
  TraumatologyIcon,
  CardiologyIcon,
  DermatologyIcon,
  FelineMedicineIcon,
  EndocrinologyIcon,
  NephrourologyIcon,
  DentistryIcon,
  OphthalmologyIcon,
  NutritionIcon,
  GastroenterologyIcon,
  AcupunctureIcon,
  GeneralMedicineIcon,
  GeriatricsIcon,
  OncologyIcon,
  PulmonologyIcon,
  ExoticMedicineIcon,
} from "../icons";

const Consultas = () => {
  const galleryPhotos = [
    { src: photoConsult, alt: "Consulta veterinaria" },
    { src: photoExam, alt: "Examen clínico" },
    { src: photoFisio, alt: "Fisioterapia" },
    { src: photoExam3, alt: "Evaluación neurológica" },
    { src: photoConsult2, alt: "Consulta médica" },
  ];

  const services = [
    {
      icon: <NeurologyIcon />,
      title: "Neurología",
      description:
        "Diagnóstico y tratamiento de trastornos del sistema nervioso central y periférico.",
      delay: ".2s",
    },
    {
      icon: <PhysiatryIcon />,
      title: "Fisiatría",
      description:
        "Terapia física y rehabilitación para recuperación post-quirúrgica y movilidad.",
      delay: ".3s",
    },
    {
      icon: <TraumatologyIcon />,
      title: "Traumatología",
      description:
        "Atención especializada en lesiones óseas, fracturas y ortopedia veterinaria.",
      delay: ".4s",
    },
    {
      icon: <CardiologyIcon />,
      title: "Cardiología",
      description:
        "Evaluación cardíaca completa y manejo de enfermedades del corazón.",
      delay: ".5s",
    },
    {
      icon: <DermatologyIcon />,
      title: "Dermatología",
      description:
        "Diagnóstico y tratamiento de alergias, infecciones y afecciones cutáneas.",
      delay: ".6s",
    },
    {
      icon: <FelineMedicineIcon />,
      title: "Medicina Felina",
      description:
        "Atención especializada exclusiva para gatos y sus necesidades únicas.",
      delay: ".7s",
    },
    {
      icon: <EndocrinologyIcon />,
      title: "Endocrinología",
      description:
        "Diagnóstico y manejo de trastornos hormonales y metabólicos.",
      delay: ".7s",
    },
    {
      icon: <NephrourologyIcon />,
      title: "Nefrourología",
      description:
        "Cuidado integral de riñones y sistema urinario de tu mascota.",
      delay: ".7s",
    },
    {
      icon: <DentistryIcon />,
      title: "Odontología",
      description: "Limpieza dental, extracciones y cuidado bucal completo.",
      delay: ".7s",
    },
    {
      icon: <OphthalmologyIcon />,
      title: "Oftalmología",
      description:
        "Evaluación y tratamiento de problemas oculares y de la visión.",
      delay: ".7s",
    },
    {
      icon: <NutritionIcon />,
      title: "Nutrición",
      description:
        "Planes alimenticios personalizados para la salud óptima de tu mascota.",
      delay: ".7s",
    },
    {
      icon: <GastroenterologyIcon />,
      title: "Gastroenterología",
      description:
        "Diagnóstico y tratamiento de problemas digestivos e intestinales.",
      delay: ".7s",
    },
    {
      icon: <AcupunctureIcon />,
      title: "Acupuntura",
      description:
        "Terapia complementaria para el manejo del dolor y bienestar general.",
      delay: ".7s",
    },
    {
      icon: <GeneralMedicineIcon />,
      title: "Medicina General",
      description:
        "Chequeos preventivos, vacunación y atención veterinaria integral.",
      delay: ".7s",
    },
    {
      icon: <GeriatricsIcon />,
      title: "Geriatría",
      description:
        "Cuidado especializado para mascotas en su etapa de adulto mayor.",
      delay: ".7s",
    },
    {
      icon: <OncologyIcon />,
      title: "Oncología",
      description:
        "Diagnóstico, tratamiento y seguimiento de enfermedades neoplásicas.",
      delay: ".7s",
    },
    {
      icon: <PulmonologyIcon />,
      title: "Broncopulmonar",
      description:
        "Atención de afecciones respiratorias y del sistema pulmonar.",
      delay: ".7s",
    },
    {
      icon: <ExoticMedicineIcon />,
      title: "Medicina Animales Exóticos",
      description:
        "Atención veterinaria especializada para aves, reptiles y otros exóticos.",
      delay: ".7s",
    },
  ];

  return (
    <>
      {/* Services Section */}
      <section id="services" className="relative z-10 pt-[110px] pb-[110px]">
        <DecorativeCircle position="right-bottom" />

        <div className="container">
          <div
            className="wow fadeInUp mx-auto mb-14 max-w-[690px] text-center lg:mb-[70px]"
            data-wow-delay=".2s"
          >
            <h2 className="mb-4 text-3xl font-bold text-black dark:text-white sm:text-4xl md:text-[44px] md:leading-tight">
              Nuestras Consultas Médicas
            </h2>
            <p className="text-base text-body">
              Ofrecemos diversos servicios de consulta veterinaria general y de
              especialidad.
            </p>
          </div>
        </div>

        <div className="container max-w-[1390px]">
          <div className="px-5 bg-white rounded-2xl pt-14 pb-14 shadow-card dark:bg-dark dark:shadow-card-dark md:pb-1 lg:pt-20 lg:pb-5 xl:px-10">
            <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
              {services.map((service, index) => (
                <ServiceCard
                  key={index}
                  icon={service.icon}
                  title={service.title}
                  description={service.description}
                  delay={service.delay}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      <PhotoGallery
        photos={galleryPhotos}
        title="Nuestras Consultas"
        description="Atención profesional y cercana en cada consulta."
      />

      <BookUsBanner />
    </>
  );
};

export default Consultas;
